import { gql } from '@apollo/client';

export interface LpisDetail {
  code: string | null;
  square: string | null;
  nationalCode: string | null;
  areaHa: number | null;
  culture: string | null;
  companyName: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  cropName: string | null;
  cropYear: number | null;
}

export const GET_LPIS_DETAIL_QUERY = gql`
  query GetLpisDetail($parcelIds: [Int!]!, $userId: Int, $code: String) {
    getLpisDetail(parcelIds: $parcelIds, userId: $userId, code: $code) {
      code
      square
      nationalCode
      areaHa
      culture
      companyName
      firstName
      lastName
      email
      phone
      cropName
      cropYear
    }
  }
`;
